module.exports = __webpack_public_path__ + "img/phone.8813a346.png";